import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import api from '@/api';
import { NotFoundScreen } from '@/common/ErrorScreen';
import { TitleWithQuestion } from '@/common/TitleWithQuestion';
import StudentFollowUpRequestsTable from '@/tables/StudentFollowUpRequestsTable';
import { GroupHeaderWrapper } from '~/styles/layoutElements';

export const Route = createFileRoute(
  '/_app/_users/members/$memberId/follow-ups/',
)({
  component: MemberFollowUpRequestsScreen,
});

function MemberFollowUpRequestsScreen() {
  const { t } = useTranslation();
  const { memberId } = Route.useParams();
  const studentId = Number(memberId);

  // Defence in depth over the SAME set as the shell, not a narrower one: a
  // student typing the URL clears nothing here, but a coordinator whose relation
  // is revoked between renders must not keep seeing rows. Same query key as the
  // shell's, so react-query dedupes it.
  const { data: access, isLoading } = api.getStudentFollowUpsAccess.useQuery({
    path: { student_id: studentId },
  });

  if (isLoading) return null;
  if (access?.can_view !== true) return <NotFoundScreen />;

  return (
    <Container>
      <GroupHeaderWrapper>
        <TitleWithQuestion title={t('wbs.all-follow-up-requests')} />
      </GroupHeaderWrapper>
      <StudentFollowUpRequestsTable
        studentId={studentId}
        studentName={access.display_name ?? ''}
      />
    </Container>
  );
}

const Container = styled.div`
  margin-bottom: 40px;
`;
